import React, { PropsWithChildren } from 'react';
import { useDragLayer, XYCoord } from 'react-dnd';

import styles from './saved-report-drag-preview-item.scss';

const elementSpacing = 30;

const getItemStyles = (
  initialOffset: XYCoord | null,
  currentOffset: XYCoord | null
) => {
  if (!initialOffset || !currentOffset) {
    return {
      display: 'none'
    };
  }

  const { x, y } = currentOffset;
  const transform = `translate(${x - elementSpacing}px, ${y}px)`;

  return {
    transform,
    WebkitTransform: transform
  };
};

interface SavedReportDragPreviewItemProps<T> {
  renderItem: (item: T) => React.ReactNode;
  itemType: string;
}

export const SavedReportDragPreviewItemProps = <T extends {}>({
  renderItem, itemType
}: PropsWithChildren<SavedReportDragPreviewItemProps<T>>) => {

  const {
    item,
    currentItemType,
    initialOffset,
    currentOffset,
    isDragging
  } = useDragLayer((monitor) => ({
    item: monitor.getItem(),
    currentItemType: monitor.getItemType(),
    initialOffset: monitor.getInitialSourceClientOffset(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging()
  }));

  if (!isDragging || currentItemType !== itemType) {
    return null;
  }

  return <div className={styles.previewContainer}>
    <div style={getItemStyles(initialOffset, currentOffset)}>
      {renderItem(item)}
    </div>
  </div>;
};
